<template>
  <div style="height: 100%;">
    <div class="title">错峰用餐</div>
    <div class="box">
      <div class="left_nav">
        <div class="search_title">
          <div></div>
          <!-- <el-input class="search" size="mini" v-model="input" placeholder="搜索分组"><i slot="prefix"
              class="el-input__icon el-icon-search"></i></el-input> -->
          <el-button class="add_btn" size="mini" icon="el-icon-plus" circle @click="handleAddGroup"></el-button>
        </div>

        <div class="class_list">
          <!-- 循环列表 -->
          <div class="class_list_item" v-for="(value, index) in classList" :key="value.id"
            :class="{ active: index === selectClassIndex }" @click="tabGroup(index)">
            <p>{{ value.name }}</p>

            <!-- 关键点：将 Popover 放在循环内部 -->
            <el-popover placement="right" width="100" trigger="click" :ref="`popover-${index}`"
              popper-class="my-popover-style">
              <!-- 弹窗里的菜单内容 -->
              <div class="popover-menu">
                <div class="menu-item" @click="handleEdit(value, index)">重命名</div>
                <div class="menu-item delete" @click="handleDelete(value, index)">删除分组</div>
              </div>

              <!-- 触发元素：把 i 标签放在 reference 插槽中 -->
              <i slot="reference" class="el-icon-more"></i>
            </el-popover>
          </div>
          <div class="notDinner" v-if="classList.length === 0">
            <img src="../assets/notDinner.webp" alt="">
            <p>暂无分组信息</p>
          </div>
        </div>
      </div>
      <div class="right_content">
        <div class="search_title">
          <el-input class="search" size="mini" v-model="searchGroupName" @change="getGroupUserList"
            placeholder="搜索人员"><i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>
          <div class="">
            <el-button size="mini" @click="dialogUserVisible = true">添加人员</el-button>
            <el-button size="mini" type="primary" @click="updateVisible = true">导入人员</el-button>
          </div>
        </div>
        <div class="dinner_time" v-if="selectClassItem && selectClassItem.list && selectClassItem.list.length !== 0">
          <i class="el-icon-info"></i>
          <span v-if="mealTypes[0].time">早餐：{{ mealTypes[0].time }}之后</span>
          <span v-else>早餐：--</span>
          <span v-if="mealTypes[1].time">午餐：{{ mealTypes[1].time }}之后</span>
          <span v-else>午餐：--</span>
          <span v-if="mealTypes[2].time">晚餐：{{ mealTypes[2].time }}之后</span>
          <span v-else>晚餐：--</span>
          <span v-if="mealTypes[3].time">夜宵：{{ mealTypes[3].time }}之后</span>
          <span v-else>夜宵：--</span>
          <el-button size="mini" type="primary" @click="handleOpenTimeSetting">修改</el-button>
        </div>
        <div class="warning" v-else>
          <i class="el-icon-info"></i>
          <p>暂未设置用餐时间</p>
          <el-button size="mini" type="warning" @click="handleOpenTimeSetting">去设置</el-button>
        </div>
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="userName" label="人员姓名">
          </el-table-column>
          <el-table-column prop="mobile" label="手机号" align="center">
          </el-table-column>
          <el-table-column label="其他操作" align="center">
            <template slot-scope="scope">
              <!-- <el-button type="text">移动</el-button> -->
              <el-button type="text" @click="delGroupUserFn(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" :page-size="size" :current-page.sync="page" align='center'
          @current-change="pageChange" :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 2. 添加创建分组的对话框 -->
    <el-dialog :title="editingGroupId ? '修改分组名称' : '创建用餐分组'" :visible.sync="dialogVisible" width="400px" :close-on-click-modal="false"
      @close="resetForm">
      <el-form :model="groupForm" :rules="rules" ref="groupForm" label-width="80px">
        <el-form-item label="分组名称" prop="name">
          <el-input v-model="groupForm.name" placeholder="请输入分组名称" maxlength="10" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="submitGroup" size="small">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 新增：设置用餐时间的弹窗 -->
    <el-dialog title="设置用餐时间" :visible.sync="dialogTimeVisible" width="500px" custom-class="time-setting-dialog">
      <div class="time-setting-container">
        <div class="time-row" v-for="(item, key) in mealTypes" :key="key">
          <div class="meal-label">{{ item.label }}</div>
          <el-time-picker v-model="item.time" placeholder="选择时间" value-format="HH:mm" size="small"></el-time-picker>
          <span class="after-text">之后</span>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTimeVisible = false">取消</el-button>
        <el-button type="primary" @click="setTimeFn()">完成</el-button>
      </div>
    </el-dialog>
    <!-- 2. 添加人员弹窗 -->
    <el-dialog title="添加人员" :visible.sync="dialogUserVisible" width="700px" custom-class="add-user-dialog"
      @close="resetUserDialog">
      <div class="transfer-box">
        <!-- 左侧：查找区 -->
        <div class="transfer-left">
          <div class="section-title">查找</div>
          <div class="search-form">
            <span class="label"><i style="color: #f56c6c; margin-right: 4px;">*</i>手机号</span>
            <el-input placeholder="请输入" v-model="userSearchPhone" size="small" class="search-input">
              <el-button slot="append" type="primary" @click="showAllUser()" class="search-inner-btn">查询</el-button>
            </el-input>
          </div>
          <!-- 这里可以预留搜索结果展示区域 -->
          <div class="search-result">
            <el-checkbox v-if="searchUser && searchUser.userName" @change="selectChange">{{
              searchUser.userName }}</el-checkbox>
          </div>
        </div>

        <!-- 右侧：已选区 -->
        <div class="transfer-right">
          <div class="section-title">已选中 ({{ selectedList.length }})</div>
          <div class="selected-content">
            <!-- 循环显示已选人员 -->
            <p v-if="selectedList.length === 0" style="color: #999; font-size: 13px; margin-top: 10px;">暂无选中人员</p>
            <div class="select-box" v-else>
              <div v-for="value in selectedList" :key="value.userId || value.phone || value.mobile">{{ value.userName }}</div>
            </div>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogUserVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="handleConfirmAddUser" size="small"
          :disabled="selectedList.length === 0">添加</el-button>
      </div>
    </el-dialog>
    <!-- 导入人员上传 -->
    <el-dialog title="导入人员" :visible.sync="updateVisible" width="600px" custom-class="add-user-dialog"
      @close="resetImportDialog">
      <el-upload ref="importUpload" class="upload-demo" style="width: 550px;" drag action="" :auto-upload="false"
        :http-request="updateFileFn" :limit="1" accept=".xls,.xlsx"
        :on-exceed="handleImportExceed" :before-upload="beforeImportUpload">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传 .xls/.xlsx 文件，且最多上传 1 个文件</div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="updateFile()" size="small">导入</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getGropuList, addGropu, delGropu, addGroupTime, getCompanyUser, getGroupUser, addGroupUser, delGroupUser, importGroupUser } from '@/api/meals'
import bus from '@/utils/bus'

const getDefaultMealTypes = () => [
  { label: '早餐', time: '07:00', type: 1 },
  { label: '午餐', time: '12:00', type: 2 },
  { label: '晚餐', time: '18:00', type: 3 },
  { label: '夜宵', time: '22:00', type: 4 }
]

export default {
  data () {
    return {
      input: '',
      classList: [
      ],
      tableData: [],
      // 3. 定义弹窗相关的变量
      dialogVisible: false,
      groupForm: {
        name: ''
      },
      editingGroupId: '',
      rules: {
        name: [
          { required: true, message: '请输入分组名称', trigger: 'blur' },
          { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
        ]
      },
      dialogTimeVisible: false,
      mealTypes: getDefaultMealTypes(),
      dialogUserVisible: false, // 控制添加人员弹窗
      userSearchPhone: '', // 搜索框输入的手机号
      searchUser: {}, // 搜索到的人员
      selectedList: [], // 已选中的人员列表
      selectClassIndex: 0,
      selectClassItem: {
        list: []
      },
      companyId: '',
      page: 1,
      size: 10,
      total: 0,
      searchGroupName: '',
      updateVisible: false,
      importing: false
    }
  },
  mounted () {
    this.companyId = localStorage.companyId
    this.getList()
    bus.$on('changeCompany', this.handleChangeCompany)
  },
  destroyed () {
    bus.$off('changeCompany', this.handleChangeCompany)
  },
  methods: {
    handleChangeCompany (id) {
      if (this.$route.name !== 'OffPeakDining') {
        return
      }
      this.companyId = id
      this.resetPageData()
      this.getList()
    },
    resetPageData () {
      this.classList = []
      this.tableData = []
      this.selectClassIndex = 0
      this.selectClassItem = { list: [] }
      this.page = 1
      this.total = 0
      this.searchGroupName = ''
      this.dialogVisible = false
      this.dialogTimeVisible = false
      this.dialogUserVisible = false
      this.updateVisible = false
      this.groupForm.name = ''
      this.editingGroupId = ''
      this.userSearchPhone = ''
      this.searchUser = {}
      this.selectedList = []
      this.importing = false
      this.mealTypes = getDefaultMealTypes()
      if (this.$refs.importUpload) {
        this.$refs.importUpload.clearFiles()
      }
    },
    getList () {
      getGropuList(this.companyId).then(res => {
        this.classList = res || []
        if (this.classList.length === 0) {
          this.selectClassIndex = 0
          this.selectClassItem = { list: [] }
          this.tableData = []
          this.total = 0
          this.mealTypes = getDefaultMealTypes()
          return
        }
        this.selectClassIndex = 0
        this.selectClassItem = this.classList[0]
        this.tabGroup(0)
      })
    },
    handleEdit (item, index) {
      this.editingGroupId = item.id
      this.groupForm.name = item.name
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.groupForm) {
          this.$refs.groupForm.clearValidate()
        }
      })
      // 逻辑处理...

      // 处理完手动关闭弹窗（ElementUI v2 技巧）
      this.$refs[`popover-${index}`][0].doClose()
    },
    handleDelete (item, index) {
      delGropu(item.id).then(res => {
        this.$message.success('删除成功')
        this.getList()
      })

      this.$refs[`popover-${index}`][0].doClose()
    },
    // 打开弹窗
    handleAddGroup () {
      this.editingGroupId = ''
      this.groupForm.name = ''
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.groupForm) {
          this.$refs.groupForm.clearValidate()
        }
      })
    },
    // 提交创建分组
    submitGroup () {
      this.$refs.groupForm.validate((valid) => {
        if (valid) {
          // 模拟提交成功
          let data = {
            companyId: localStorage.companyId,
            name: this.groupForm.name
          }
          if (this.editingGroupId) {
            data.id = this.editingGroupId
          }
          addGropu(data).then(res => {
            this.$message.success(this.editingGroupId ? '修改成功' : '创建成功')
            this.getList()
            this.dialogVisible = false
          })
        } else {
          return false
        }
      })
    },
    // 关闭弹窗重置表单
    resetForm () {
      this.editingGroupId = ''
      if (this.$refs.groupForm) {
        this.$refs.groupForm.resetFields()
      }
    },
    handleOpenTimeSetting () {
      this.dialogTimeVisible = true
    },
    // 获取所有员工列表
    showAllUser () {
      this.searchUser = {}
      if (!this.userSearchPhone) {
        this.$message.warning('请输入手机号后再查询')
        return
      }
      let data = {
        phone: this.userSearchPhone,
        companyId: this.companyId
      }
      getCompanyUser(data).then(res => {
        this.searchUser = res || {}
        this.searchUser.checked = false
        this.searchUser.phone = this.userSearchPhone
      })
    },
    resetUserDialog () {
      this.userSearchPhone = ''
      this.searchUser = {}
      this.selectedList = []
    },
    setTimeFn () {
      let data = {
        id: this.selectClassItem.id,
        mealsGroupTimes: []
      }
      this.mealTypes.forEach(item => {
        data.mealsGroupTimes.push({
          stime: item.time,
          type: item.type
        })
      })
      addGroupTime(data).then(res => {
        const mealsGroupTimes = data.mealsGroupTimes.map(item => ({ ...item }))
        this.$set(this.selectClassItem, 'list', mealsGroupTimes)
        if (this.classList[this.selectClassIndex]) {
          this.$set(this.classList[this.selectClassIndex], 'list', mealsGroupTimes)
          this.selectClassItem = this.classList[this.selectClassIndex]
        }
        this.$message({
          type: 'success',
          message: `添加成功`
        })
        this.dialogTimeVisible = false
      })
    },
    getGroupUserList () {
      if (!this.selectClassItem || !this.selectClassItem.id) {
        this.tableData = []
        this.total = 0
        return
      }
      let data = {
        groupId: this.selectClassItem.id,
        page: this.page,
        size: this.size,
        userName: this.searchGroupName
      }
      getGroupUser(data).then(res => {
        this.tableData = res.list
        this.total = res.total
      })
    },
    pageChange (page) {
      this.page = page
      this.getGroupUserList()
    },
    tabGroup (i) {
      if (typeof i === 'undefined') {
        i = 0
      }
      const currentGroup = this.classList[i]
      this.selectClassIndex = i
      this.selectClassItem = currentGroup || { list: [] }
      if (!currentGroup) {
        this.tableData = []
        this.total = 0
        this.mealTypes = getDefaultMealTypes()
        return
      }
      if (currentGroup.list && currentGroup.list.length !== 0) {
        currentGroup.list.forEach(item => {
          const type = Number(item.type)
          if (type === 1) {
            this.mealTypes[0].time = item.stime
          }
          if (type === 2) {
            this.mealTypes[1].time = item.stime
          }
          if (type === 3) {
            this.mealTypes[2].time = item.stime
          }
          if (type === 4) {
            this.mealTypes[3].time = item.stime
          }
        })
      } else {
        this.mealTypes = getDefaultMealTypes()
      }
      this.page = 1;
      this.getGroupUserList()
    },
    selectChange () {
      this.searchUser.checked = !this.searchUser.checked
      if (this.searchUser.checked && this.selectedList.length === 0) {
        this.selectedList.push(this.searchUser)
      } else if (this.searchUser.checked && this.selectedList.length > 0) {
        let inHear = false
        this.selectedList.forEach(item => {
          if (String(item.userId) === String(this.searchUser.userId)) {
            inHear = true
          }
        })
        if (!inHear) {
          this.selectedList.push(this.searchUser)
        }
      } else if (!this.searchUser.checked) {
        this.selectedList.forEach((item, index) => {
          if (String(item.userId) === String(this.searchUser.userId)) {
            this.selectedList.splice(index, 1)
          }
        })
      }
    },
    handleConfirmAddUser () {
      let data = []
      this.selectedList.forEach(item => {
        data.push({
          groupId: this.selectClassItem.id,
          userId: item.userId,
          userName: item.userName,
          mobile: item.phone
        })
      })
      addGroupUser(data).then(res => {
        this.$message({
          type: 'success',
          message: `添加成功`
        })
        this.dialogUserVisible = false
        this.selectedList = []
        this.searchUser = {}
        this.userSearchPhone = ''
        this.getGroupUserList()
      })
    },
    delGroupUserFn (data) {
      delGroupUser(data).then(res => {
        this.$message({
          type: 'success',
          message: `删除成功`
        })
        this.getGroupUserList()
      })
    },
    beforeImportUpload (file) {
      const fileName = file.name ? file.name.toLowerCase() : ''
      const isExcel = fileName.endsWith('.xls') || fileName.endsWith('.xlsx')
      if (!isExcel) {
        this.$message.error('只能上传 .xls 或 .xlsx 文件')
      }
      return isExcel
    },
    handleImportExceed () {
      this.$message.warning('最多只能上传 1 个文件')
    },
    resetImportDialog () {
      this.importing = false
      if (this.$refs.importUpload) {
        this.$refs.importUpload.clearFiles()
      }
    },
    updateFile () {
      if (!this.selectClassItem.id) {
        this.$message.error('当前分组无效，请重新选择分组')
        return
      }
      const files = this.$refs.importUpload ? this.$refs.importUpload.uploadFiles : []
      if (!files || files.length === 0) {
        this.$message.warning('请先选择要导入的 Excel 文件')
        return
      }
      if (this.importing) {
        return
      }
      this.importing = true
      this.$refs.importUpload.submit()
    },
    updateFileFn (file) {
      const fd = new FormData()
      fd.append('file', file.file)
      importGroupUser(this.selectClassItem.id, fd).then(() => {
        this.$message.success('导入成功')
        this.updateVisible = false
        this.resetImportDialog()
        this.getGroupUserList()
      }).catch(() => {
        this.$message.error('导入失败')
      }).finally(() => {
        this.importing = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/* 原有样式保持不变 */
.title {
  height: 40px;
}

.box {
  height: calc(100% - 60px);
  display: flex;
  border-top: 1px solid rgba(0, 0, 0, 0.1);

  .left_nav {
    width: 220px;
    border-right: 1px solid rgba(0, 0, 0, 0.1);
    padding: 15px;

    .search_title {
      display: flex;
      justify-content: space-between;
    }

    .class_list {
      margin-top: 20px;

      .class_list_item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 35px;
        padding: 0 5px;
        border-radius: 3px;
        margin-bottom: 2px;

        &:hover {
          background: rgba(0, 0, 0, 0.1);
        }

        i {
          cursor: pointer;
          padding: 5px;
        }

        // 增加点击区域
      }
    }
    .notDinner{
      margin:0 auto;
      margin-top:40px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img{
        width: 80px;
        height: 80px;
      }
    }
  }
}

.right_content {
  flex: 1;
  padding: 15px;

  .search_title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .dinner_time {
    margin: 10px 0;
    background-color: rgba($color: #409EFF, $alpha: 0.3);
    color: #409EFF;
    padding: 5px 8px;
    display: flex;
    align-items: center;

    i {
      margin-right: 5px;
    }

    span {
      margin-right: 15px;
      font-size: 13px;

    }
  }

  .warning {
    margin: 10px 0;
    background-color: rgba($color: #E6A23C, $alpha: 0.3);
    padding: 5px 8px;
    display: flex;
    align-items: center;

    i {
      margin-right: 5px;
      color: #E6A23C;
    }

    p {
      margin-right: 15px;
      font-size: 13px;
    }
  }
}

.search {
  width: 180px;
  margin-right: 10px;
}

/* 新增弹窗内部菜单样式 */
.popover-menu {
  .menu-item {
    padding: 8px 12px;
    cursor: pointer;
    font-size: 14px;

    &:hover {
      background-color: #f5f7fa;
      color: #409EFF;
    }

    &.delete {
      color: #F56C6C;

      &:hover {
        background-color: #fef0f0;
      }
    }
  }
}

/* 弹窗内部布局 */
.time-setting-container {
  padding: 10px 40px;

  .time-row {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    .meal-label {
      width: 50px;
      height: 26px;
      background-color: #5b70f9; // 图片中的蓝色
      color: white;
      text-align: center;
      line-height: 26px;
      font-size: 13px;
      border-radius: 3px;
      margin-right: 20px;
    }

    .after-text {
      margin-left: 15px;
      color: #606266;
      font-size: 14px;
    }

    /* 调整时间选择器的宽度 */
    .el-date-editor.el-input {
      width: 220px;
    }
  }
}

/* 覆盖 ElementUI 默认样式 */
::v-deep .time-setting-dialog {
  border-radius: 8px;

  .el-dialog__header {
    border-bottom: 1px solid #f0f0f0;
    padding: 20px;
  }

  .el-dialog__title {
    font-size: 16px;
    font-weight: bold;
  }

  .el-dialog__footer {
    padding: 10px 20px 20px;
    text-align: right;
  }
}

/* 弹窗整体布局 */
.transfer-box {
  display: flex;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  height: 350px; // 固定高度

  .transfer-left,
  .transfer-right {
    flex: 1;
    padding: 20px;
  }

  .section-title {
    height: 30px;
  }

  .select-box {
    height: 260px;
    overflow: auto;
  }

  .transfer-left {
    border-right: 1px solid #ebeef5; // 中间分割线
  }

  .section-title {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 20px;
    color: #333;
  }

  .search-form {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    .label {
      font-size: 13px;
      width: 70px;
    }

    .search-input {
      flex: 1;
    }
  }
}

/* 覆盖 ElementUI 样式以匹配图片 */
::v-deep .add-user-dialog {
  border-radius: 8px;

  .el-dialog__header {
    padding: 20px;
    border-bottom: 1px solid #f0f0f0;
  }

  .el-dialog__body {
    padding: 20px; // 弹窗内边距
  }

  // 输入框后的查询按钮样式
  .el-input-group__append {
    background-color: #e8ecff !important; // 浅蓝色背景
    color: #5b70f9 !important;
    border: none;
    font-size: 12px;
  }

  .el-dialog__footer {
    border-top: 1px solid #f0f0f0;
    padding: 15px 20px;
  }
}

.active {
  background: rgba(0, 0, 0, 0.1);
}
</style>

<style lang="scss">
/* 注意：修改 ElementUI 弹窗内边距通常需要全局样式或非 scoped 样式 */
.my-popover-style {
  padding: 5px 0 !important; // 去掉默认的大内边距，让它更像菜单
  min-width: 100px !important;
}
</style>
